export const addClassAndTargetToInnerHtmlConsentText = (consentText: string): string => {
  if (!consentText) {
    return consentText;
  }
  let enrichedConsentLabel = consentText;

  const regex = /<a\s+(?:[^>]*?\s+)?href=(["'])(.*?)\1(?:[^>]*?)?>/gi;
  enrichedConsentLabel = enrichedConsentLabel.replace(regex, (match, quote, href) => {
    return `<a class="underline" target="_blank" href="${href}">`;
  });

  return enrichedConsentLabel;
};
